// extracted by mini-css-extract-plugin
module.exports = {"tags":"style_tags__YvMjU"};